import React, { useState, useEffect } from 'react';

const ModalReagendar = ({
  show,
  onClose,
  onSubmit,
  cita,
  horasDisponibles,
  horasCargadas,
  onCargarHoras,
  loading = false
}) => {
  const [reagendarForm, setReagendarForm] = useState({ nueva_fecha: '', nueva_hora: '' });
  const [errores, setErrores] = useState({});

  useEffect(() => {
    if (cita) {
      setReagendarForm({ nueva_fecha: cita.fecha_cita || '', nueva_hora: cita.hora_inicio || '' });
    }
  }, [cita, show]);

  const validar = () => {
    const nuevosErrores = {};

    if (!reagendarForm.nueva_fecha) {
      nuevosErrores.nueva_fecha = 'Selecciona una fecha';
    }

    if (!reagendarForm.nueva_hora) {
      nuevosErrores.nueva_hora = 'Selecciona una hora';
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validar()) {
      onSubmit(reagendarForm.nueva_fecha, reagendarForm.nueva_hora);
    }
  };

  const handleClose = () => {
    setErrores({});
    onClose();
  };

  if (!show || !cita) return null;

  const inputStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    width: '100%',
    marginTop: '0.5rem',
    transition: 'all 0.2s'
  };

  const errorStyle = {
    color: '#dc2626',
    fontSize: '0.85rem',
    marginTop: '0.25rem'
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '500px', borderRadius: '16px', overflow: 'hidden' }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>🔄</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              Reagendar Cita
            </h3>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          {/* Fecha actual */}
          <div style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.85rem', color: '#6b7280' }}>Fecha actual</p>
            <p style={{ margin: 0, fontWeight: '600', color: '#374151' }}>
              {new Date(cita.fecha_cita).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
              {' a las '}
              {cita.hora_inicio}
            </p>
          </div>

          {/* Nueva Fecha */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Nueva Fecha *</label>
            <input
              type="date"
              value={reagendarForm.nueva_fecha}
              onChange={(e) => {
                setReagendarForm({ ...reagendarForm, nueva_fecha: e.target.value });
                onCargarHoras(e.target.value, cita.servicio_id);
              }}
              style={{ ...inputStyle, borderColor: errores.nueva_fecha ? '#dc2626' : 'rgba(59, 130, 246, 0.3)' }}
              disabled={loading}
            />
            {errores.nueva_fecha && <div style={errorStyle}>{errores.nueva_fecha}</div>}
          </div>

          {/* Nueva Hora */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Nueva Hora *</label>
            {horasCargadas ? (
              <select
                value={reagendarForm.nueva_hora}
                onChange={(e) => setReagendarForm({ ...reagendarForm, nueva_hora: e.target.value })}
                style={{ ...inputStyle, borderColor: errores.nueva_hora ? '#dc2626' : 'rgba(59, 130, 246, 0.3)' }}
                disabled={loading}
              >
                <option value="">-- Selecciona hora --</option>
                {horasDisponibles.map(hora => (
                  <option key={hora} value={hora}>{hora}</option>
                ))}
              </select>
            ) : (
              <input type="text" placeholder="Cargando horarios..." style={{ ...inputStyle, backgroundColor: '#f3f4f6' }} disabled />
            )}
            {errores.nueva_hora && <div style={errorStyle}>{errores.nueva_hora}</div>}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Reagendando...' : 'Reagendar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalReagendar;
